import ContractSectionCards from "./ContractSectionCards"

export default ContractSectionCards